function swymCallbackFn(swat){
    // your API calls go here
  document.addEventListener("swym:collections-loaded", function(){
    swat.initializeActionButtons(".product-grid");
  })
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

//ghd catogery mf_ multiple filter issue


  document.addEventListener("DOMContentLoaded", function () {
    const isGHDCollection = window.location.pathname.includes("/collections/ghd");

    if (!isGHDCollection) return;

    // Look for the Wetline checkbox under category filter
    const observer = new MutationObserver(() => {
      const wetlineCheckbox = Array.from(document.querySelectorAll('[data-type="category"]')).find(el =>
        el.textContent?.trim().toLowerCase().includes("wetline")
      );

      if (wetlineCheckbox && !wetlineCheckbox.dataset._patched) {
        wetlineCheckbox.dataset._patched = true;

        wetlineCheckbox.addEventListener("click", function () {
          const url = new URL(window.location.href);
          const hasMetaWetline = url.searchParams.get("mf_custom_collection:text")?.toLowerCase() === "wetline";

          if (hasMetaWetline) {
            // Remove metafield and redirect
            url.searchParams.delete("mf_custom_collection:text");
            window.location.href = url.toString();
          }
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

//Desktop sticky menu

document.addEventListener('DOMContentLoaded', function () {
  window.addEventListener('scroll', () => {
    if (window.innerWidth < 989) return; // Only for desktop

    const sticky = document.querySelector('.shopify-section-header-sticky');
    if (!sticky) return;

    const hideTargets = [
      document.querySelector('.background_bela'),
      sticky.querySelector('.header__left'),
      sticky.querySelector('.header_center_d'),
      sticky.querySelector('.header__right .accnt')
    ];

    const stickyLogo = sticky.querySelector('.stickylogo');
    const menuSplit = sticky.querySelector('.header__menu-split');
    const stickyTop = sticky.getBoundingClientRect().top;

    hideTargets.forEach(el => {
      if (el) el.style.display = (stickyTop <= 0) ? 'none' : '';
    });

    if (stickyLogo) {
      stickyLogo.style.display = (stickyTop <= 0) ? 'block' : '';
    }

    if (menuSplit) {
      if (stickyTop <= 0) {
        menuSplit.style.marginTop = '-27px';
        menuSplit.classList.add('sticky-h');
      } else {
        menuSplit.style.marginTop = '';
        menuSplit.classList.remove('sticky-h');
      }
    }


    // ✅ ONLY set position: absolute; top: 17px; on scroll
    const cartDrawer = sticky.querySelector('.header__right cart-drawer');
    if (cartDrawer) {
      if (stickyTop <= 0) {
        cartDrawer.style.position = 'absolute';
        cartDrawer.style.top = '17px';
        cartDrawer.style.marginLeft = '-15px';
        //cartDrawer.style.visibility = 'hidden';
      } else {
        cartDrawer.style.position = '';
        cartDrawer.style.top = '';
        cartDrawer.style.marginLeft = '';
        //cartDrawer.style.visibility = '';
      }
    }
  });
});


//Sf hoe slider scripts 

document.addEventListener("DOMContentLoaded", function () {
  // ----- Swiper (delay init so our first play runs after active slide is set) -----
  const swiper = new Swiper('.sfhomeslider', {
    loop: true,
    autoplay: { delay: 8000, disableOnInteraction: false },
    pagination: { el: '.swiper-pagination', clickable: true },
    init: false,
  });

  // ----- Mobile height -----
  const slider = document.querySelector('.custom-slider');
  if (slider && window.innerWidth <= 768) {
    slider.style.height = slider.dataset.mobileHeight + 'vh';
  }

  // ----- Always keep a poster on mobile -----
  const isMobile = window.innerWidth <= 768;
  if (isMobile) {
    document.querySelectorAll('.custom-slide').forEach(slide => {
      const mobileBg = slide.getAttribute('data-bg-mobile');
      if (mobileBg) slide.style.backgroundImage = `url('${mobileBg}')`;
    });
  }

  function prepareVideo(slide) {
    const v = slide?.querySelector('video.custom-slide__video-bg');
    if (!v) return null;

    // iOS-safe flags BEFORE touching src
    v.muted = true;
    v.defaultMuted = true;
    v.volume = 0.0;
    v.setAttribute('muted', 'muted');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('autoplay', '');
    v.removeAttribute('controls');

    // Choose source
    const src = (isMobile
      ? (slide.getAttribute('data-video-mobile') || slide.getAttribute('data-video-desktop'))
      : (slide.getAttribute('data-video-desktop') || slide.getAttribute('data-video-mobile'))
    ) || '';

    if (!src) return v;

    // Only set if changed (use direct .src for iOS reliability)
    if (!v.src || !v.src.endsWith(src)) {
      try {
        v.src = src;            // <-- key difference for iOS
      } catch(e) {
        v.setAttribute('src', src);
      }
      v.load();
    }

    v.classList.remove('is-ready');
    v.addEventListener('playing', function onPlaying() {
      v.classList.add('is-ready');
      v.removeEventListener('playing', onPlaying);
    });

    return v;
  }

  function pauseAll() {
    document.querySelectorAll('video.custom-slide__video-bg').forEach(v => {
      try { v.pause(); } catch(e) {}
      v.classList.remove('is-ready');
    });
  }

  async function playActive() {
    const active = swiper.slides[swiper.activeIndex];
    if (!active) return;

    pauseAll();
    const v = prepareVideo(active);
    if (!v) return;

    // Wait until we have some data, then play
    const start = () => v.play().catch(() => {});
    if (v.readyState >= 2) {
      start();
    } else {
      const onLD = () => { v.removeEventListener('loadeddata', onLD); start(); };
      v.addEventListener('loadeddata', onLD, { once: true });
    }

    // Tiny retry (some iOS builds need one more tick)
    setTimeout(() => { v.play().catch(() => {}); }, 50);
  }

  swiper.on('slideChangeTransitionStart', playActive);
  swiper.on('resize', playActive);

  // One-time iOS unlock (covers Low Power Mode / stubborn builds)
  const unlock = () => { playActive(); window.removeEventListener('touchstart', unlock, { passive:true }); };
  window.addEventListener('touchstart', unlock, { passive:true, once:true });

  // Resume when tab visible again
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) playActive();
  });

  // Now start swiper and then play first video
  swiper.on('init', playActive);
  swiper.init();
});

//sf slider timer 

(function () {
  function initCountdowns(scope) {
    const root = scope || document;
    const timers = root.querySelectorAll('.sf-bf-countdown');
    if (!timers.length) return;

    timers.forEach(timer => {
      if (timer.__running) return;      // avoid double init per element
      timer.__running = true;

      // Safari-safe ISO parsing: allow "YYYY-MM-DD HH:MM:SS" or "...T..."
      const parseTarget = (val) => {
        if (!val) return NaN;
        let s = String(val).trim();
        if (s.indexOf('T') === -1 && s.indexOf(' ') > -1) s = s.replace(' ', 'T');
        const t = Date.parse(s);
        return isNaN(t) ? NaN : t;
      };

      const targetMs = parseTarget(timer.dataset.target);
      if (!isFinite(targetMs)) { timer.style.display = 'none'; return; }

      const daysEl  = timer.querySelector('.cd-days');
      const hoursEl = timer.querySelector('.cd-hours');
      const minsEl  = timer.querySelector('.cd-mins');
      const secsEl  = timer.querySelector('.cd-secs'); // optional

      const updateOnce = () => {
        const diff = targetMs - Date.now();
        if (diff <= 0) {
          timer.innerHTML = 'SALE STARTED!';
          return false;
        }
        const d = Math.floor(diff / 86400000);                 // 24*60*60*1000
        const h = Math.floor((diff % 86400000) / 3600000);     // 60*60*1000
        const m = Math.floor((diff % 3600000) / 60000);        // 60*1000
        const s = Math.floor((diff % 60000) / 1000);

        if (daysEl)  daysEl.textContent  = String(d).padStart(2,'0');
        if (hoursEl) hoursEl.textContent = String(h).padStart(2,'0');
        if (minsEl)  minsEl.textContent  = String(m).padStart(2,'0');
        if (secsEl)  secsEl.textContent  = String(s).padStart(2,'0');

        return true;
      };

      // drift-free 1s tick aligned to the next second
      const tick = () => {
        if (!updateOnce()) return;
        const delay = 1000 - (Date.now() % 1000);
        timer.__t = setTimeout(tick, delay);
      };
      tick();
    });
  }

  // first run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCountdowns(document));
  } else {
    initCountdowns(document);
  }

  // re-run when the section reloads in the theme editor
  document.addEventListener('shopify:section:load', (e) => initCountdowns(e.target));
})();

(function () {

  // --- helper: parse target as LOCAL time, no manual timezone ---
  function parseTarget(val) {
    if (!val) return NaN;
    let s = String(val).trim();

    // allow "YYYY-MM-DD HH:MM:SS" or "YYYY-MM-DDTHH:MM:SS"
    if (s.indexOf('T') === -1 && s.indexOf(' ') > -1) {
      s = s.replace(' ', 'T');
    }

    const parts = s.split('T');
    if (parts.length !== 2) return NaN;

    const [datePart, timePart] = parts;
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute, second = 0] = timePart.split(':').map(Number);

    // Build as local date (customer’s device time)
    const d = new Date(
      year || 0,
      (month || 1) - 1,
      day || 1,
      hour || 0,
      minute || 0,
      second || 0
    );

    const t = d.getTime();
    return isNaN(t) ? NaN : t;
  }

  // --- helper: update videos for 1 swiper instance ---
  function updateSlideVideos(swiper) {
    if (!swiper || !swiper.slides) return;
    swiper.slides.forEach(function (slide) {
      const v = slide.querySelector('.custom-slide__video-bg');
      if (!v) return;
      try {
        if (slide.classList.contains('swiper-slide-active')) {
          v.muted = true;
          v.playsInline = true;
          v.autoplay = true;
          v.loop = true;
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      } catch (e) {}
    });
  }

  // Init Swiper for ALL .sfhomeslider instances (supports multiple sliders)
  function initSliders(scope) {
    var root = scope || document;
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('.sfhomeslider').forEach(function (sliderEl) {
      // Avoid double init
      if (sliderEl.swiper) {
        sliderEl.swiper.update && sliderEl.swiper.update();
        updateSlideVideos(sliderEl.swiper);
        return;
      }

      var paginationEl = sliderEl.querySelector('.swiper-pagination');

      sliderEl.swiper = new SfHomeSwiper(sliderEl, {
        slidesPerView: 1,
        loop: false,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
            }
          : undefined,
        on: {
          init(sw) {
            updateSlideVideos(sw);
          },
          slideChangeTransitionEnd(sw) {
            updateSlideVideos(sw);
          },
        },
      });
    });
  }

  // Init countdowns (shared)
function initCountdowns(scope) {
  const root = scope || document;
  const timers = root.querySelectorAll('.sf-bf-countdown');
  if (!timers.length) return;

  timers.forEach(timer => {
    // Always restart – important for Theme Editor changes
    if (timer.__t) clearTimeout(timer.__t);
    timer.__running = false;

    const raw = timer.getAttribute('data-target');
    const targetMs = parseTarget(raw);

    if (!isFinite(targetMs)) {
      console.warn('[BF COUNTDOWN] invalid target:', raw);
      timer.style.display = 'none';
      return;
    }

    const daysEl  = timer.querySelector('.cd-days');
const hoursEl = timer.querySelector('.cd-hours');
const minsEl  = timer.querySelector('.cd-mins');

//to go back to hours only replace this and bellow comented

/*
const hoursEl = timer.querySelector('.cd-hours');
const minsEl  = timer.querySelector('.cd-mins');
const secsEl  = timer.querySelector('.cd-secs');
*/

    const updateOnce = () => {
      const now  = Date.now();
      const diff = targetMs - now;

      if (diff <= 0) {
        timer.innerHTML = 'SALE STARTED!';
        return false;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);

      if (daysEl)  daysEl.textContent  = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minsEl)  minsEl.textContent  = String(minutes).padStart(2, '0');

      /*
      const totalSeconds = Math.floor(diff / 1000);
const totalHours   = Math.floor(totalSeconds / 3600);
const minutes      = Math.floor((totalSeconds % 3600) / 60);
const seconds      = totalSeconds % 60;

if (hoursEl) hoursEl.textContent = String(totalHours).padStart(2, '0');
if (minsEl)  minsEl.textContent  = String(minutes).padStart(2, '0');
if (secsEl)  secsEl.textContent  = String(seconds).padStart(2, '0');
      */

      return true;
    };

    const tick = () => {
      if (!updateOnce()) return;
      timer.__t = setTimeout(tick, 1000);
    };

    tick();
    timer.__running = true;
  });
}


  // (optional extra) one-time video init for any standalone videos
  function initVideos(scope) {
    var root = scope || document;
    root.querySelectorAll('.sfhomeslider .custom-slide__video-bg').forEach(function (video) {
      try {
        video.muted = true;
        video.playsInline = true;
        video.autoplay = true;
        video.loop = true;
      } catch (e) {}
    });
  }

  function initAll(scope) {
    initSliders(scope);
    initVideos(scope);
    initCountdowns(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

})();


//Addd to cart button alignement 
  (function () {
    var timer;
    var mutationObserver;
    var resizeObserver;

    function getRows(cards) {
      var rows = {};

      cards.forEach(function(card) {
        var info = card.querySelector('.card-information__wrapper');
        if (!info) return;

        info.style.minHeight = '';

        var top = Math.round(card.getBoundingClientRect().top);

        if (!rows[top]) rows[top] = [];
        rows[top].push(info);
      });

      return rows;
    }

    function alignCardInfoByRow(scope) {
      var root = scope || document;
      var cards = Array.from(root.querySelectorAll('.product-grid .grid__item .card-wrapper'));

      if (!cards.length) return;

      var rows = getRows(cards);

      Object.keys(rows).forEach(function(key) {
        var infos = rows[key];
        var maxHeight = 0;

        infos.forEach(function(info) {
          maxHeight = Math.max(maxHeight, info.offsetHeight);
        });

        infos.forEach(function(info) {
          info.style.minHeight = maxHeight + 'px';
        });
      });
    }

    function forceRealign(scope) {
      requestAnimationFrame(function () {
        alignCardInfoByRow(scope);

        setTimeout(function () {
          alignCardInfoByRow(scope);
        }, 100);

        setTimeout(function () {
          alignCardInfoByRow(scope);
        }, 250);

        setTimeout(function () {
          alignCardInfoByRow(scope);
        }, 500);
      });
    }

    function schedule(scope) {
      clearTimeout(timer);
      timer = setTimeout(function() {
        forceRealign(scope);
      }, 50);
    }

    function bindMutationObserver() {
      var container = document.querySelector('#ProductGridContainer');
      if (!container) return;

      if (mutationObserver) mutationObserver.disconnect();

      mutationObserver = new MutationObserver(function() {
        schedule(container);
        bindResizeObserver();
      });

      mutationObserver.observe(container, {
        childList: true,
        subtree: true
      });
    }

    function bindResizeObserver() {
      var wrappers = document.querySelectorAll('.product-grid .grid__item .card-information__wrapper');
      if (!wrappers.length || !window.ResizeObserver) return;

      if (resizeObserver) resizeObserver.disconnect();

      resizeObserver = new ResizeObserver(function() {
        schedule(document);
      });

      wrappers.forEach(function(el) {
        resizeObserver.observe(el);
      });
    }

    function bindImageLoadListeners() {
      var images = document.querySelectorAll('.product-grid img');
      images.forEach(function(img) {
        if (!img.complete) {
          img.addEventListener('load', function() {
            schedule(document);
          }, { once: true });
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function() {
      bindMutationObserver();
      bindResizeObserver();
      bindImageLoadListeners();
      forceRealign(document);
    });

    window.addEventListener('load', function() {
      bindMutationObserver();
      bindResizeObserver();
      bindImageLoadListeners();
      forceRealign(document);
    });

    window.addEventListener('resize', function() {
      schedule(document);
    });

    document.addEventListener('shopify:section:load', function(e) {
      bindMutationObserver();
      bindResizeObserver();
      bindImageLoadListeners();
      forceRealign(e.target);
    });

    document.addEventListener('facets:updated', function() {
      bindMutationObserver();
      bindResizeObserver();
      bindImageLoadListeners();
      forceRealign(document);
    });

    document.addEventListener('facet:update', function() {
      bindMutationObserver();
      bindResizeObserver();
      bindImageLoadListeners();
      forceRealign(document);
    });

    document.addEventListener('click', function(e) {
      if (e.target.closest('.facets') || e.target.closest('facet-filters-form')) {
        setTimeout(function() {
          bindMutationObserver();
          bindResizeObserver();
          bindImageLoadListeners();
          forceRealign(document);
        }, 300);
      }
    });
  })();

//end alignment

// yopto product page floating review
(function () {
    function updatePdpImageYotpoBadge() {
      var badge = document.querySelector('[data-pdp-yotpo-image-badge]');
      if (!badge) return false;

      var productId = badge.getAttribute('data-product-id');
      if (!productId) return false;

      var stars = badge.querySelector('[data-pdp-yotpo-stars]');
      var ratingEl = badge.querySelector('[data-pdp-yotpo-rating]');
      var countEl = badge.querySelector('[data-pdp-yotpo-count]');

      if (!stars || !ratingEl || !countEl) return false;

      var summary = document.querySelector(
        '.yotpo-widget-instance[data-yotpo-product-id="' + productId + '"] .yotpo-sr-bottom-line-summary[aria-label]'
      );

      if (!summary) return false;

      var label = summary.getAttribute('aria-label') || '';

      var ratingMatch = label.match(/([0-5](?:\.\d+)?)\s*out(?:\s+of)?\s*5/i);
      var countMatch = label.match(/(\d+)\s*reviews?/i);

      if (!ratingMatch || !countMatch) return false;

      var rating = parseFloat(ratingMatch[1]);
      var count = parseInt(countMatch[1], 10);

      if (isNaN(rating) || isNaN(count) || count <= 0) return false;

      var ratingPercent = Math.max(0, Math.min(100, (rating / 5) * 100));

      stars.style.setProperty('--rating-percent', ratingPercent + '%');
      stars.setAttribute('aria-label', rating.toFixed(1) + ' out of 5 stars');

      ratingEl.textContent = rating.toFixed(1);
      countEl.textContent = '(' + count + ')';

      badge.removeAttribute('hidden');
      badge.classList.add('is-loaded');

      return true;
    }

    function initPdpImageYotpoBadge() {
      var attempts = 0;

      var interval = setInterval(function () {
        attempts++;

        if (updatePdpImageYotpoBadge() || attempts >= 80) {
          clearInterval(interval);
        }
      }, 250);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPdpImageYotpoBadge);
    } else {
      initPdpImageYotpoBadge();
    }

    window.updatePdpImageYotpoBadge = updatePdpImageYotpoBadge;
  })();
//end yopto